import { CSSObject, SerializedStyles, css } from '@emotion/react'
import { useMemo } from 'react'
import { Theme, themes } from '@opallabs/gem'
import { variants, Variants } from './variants'

type StyleFunction = (theme: Theme) => CSSObject
const makeThemedStyles = (
  styleFunction: StyleFunction
): Record<Theme, SerializedStyles> =>
  themes.reduce(
    (acc, theme) => {
      acc[theme] = css(styleFunction(theme))
      return acc
    },
    {} as Record<Theme, SerializedStyles>
  )

export const useVariantStyle = (
  variant: Variants
): Record<Theme, SerializedStyles> =>
  useMemo(
    () => makeThemedStyles((theme) => variantStyles(theme, variant)),
    [variant]
  )

export const variantStyles = (theme: Theme, variant: Variants): CSSObject => {
  const variantConstants = variants[variant][theme]

  return {
    backgroundColor: variantConstants.baseBackground,
    color: variantConstants.foreground,
    borderColor: variantConstants.baseBorder,
    '&:hover:enabled': {
      borderColor: variantConstants.hoverBorder,
    },
    '&:hover:enabled::before': {
      backgroundColor: variantConstants.hoverOverlay,
    },
    '&:active:enabled, &[data-state=active]': {
      borderColor: variantConstants.activeBorder,
    },
    '&:active:enabled::before, &[aria-pressed=true]:enabled::before, &[aria-expanded=true]:enabled::before, &[data-state=active]::before':
      {
        backgroundColor: variantConstants.activeOverlay,
      },
  }
}
